export enum PledgingStatusTypeEnum {
  PLEDGED = 'PLEDGED',
  PAYMENT_PROCESSING = 'PAYMENT_PROCESSING',
  PLEDGE_DENIED = 'PLEDGE DENIED',
  DONATED = 'DONATED',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
}
